(function () {
  "use strict";

  const data = getData();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    mainFunc();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.locks-compare-popup.show) {
        overflow: hidden;
      }
      .itemsCategoryWrapper {
        position: relative;
      }
      .locks-compare-btn {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }
      .locks-compare-btn:active {
        transform: scale(0.98);
      }
      .locks-compare-popup {
        --nav-height: 0px;
        display: none;
        position: fixed;
        inset: 0;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
        margin-top: var(--nav-height);
        background: #fff;
        overflow: auto;
        z-index: 9999999;
      }
      .locks-compare-popup-close-btn {
        position: fixed;
        top: calc(var(--nav-height) + 1rem);
        right: 1rem;
        display: flex;
        cursor: pointer;
        z-index: 3;
      }
      .locks-compare-popup-close-btn svg {
        width: 30px;
        height: 30px;
      }
      .locks-compare-popup-close-btn:active svg {
        transform: scale(0.95);
      }
      .locks-compare-popup p {
        margin: 0;
      }
      .locks-compare-popup p.title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
      }
      .locks-compare-popup p.subtitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
      .locks-compare-popup table {
        width: 100%;
        table-layout: fixed;
      }
      .locks-compare-popup table tr {
        background: #fff;
      }
      .locks-compare-popup table tr.row_select {
        position: sticky;
        top: 0;
        z-index: 2;
      }
      .locks-compare-popup table tr.row_variant {
        position: sticky;
        top: var(--select-height);
        z-index: 1;
      }
      .locks-compare-popup table tr.row_price {
        position: sticky;
        top: calc(var(--select-height) + var(--variant-height));
        z-index: 1;
      }
      .locks-compare-popup table tr.row_cta {
        position: sticky;
        top: calc(var(--select-height) + var(--variant-height) + var(--price-height));
        z-index: 1;
      }
      .locks-compare-popup table tr.row_cutoff {
        background: transparent;
      }
      .locks-compare-popup table tr.row_cta {
        box-shadow: 0px 4px 2px -2px #00000040;
      }
      .locks-compare-popup table td {
        padding: 0px 3px;
        vertical-align: middle;
      }
      .locks-compare-popup table tr.row_select td,
      .locks-compare-popup table tr.row_variant td,
      .locks-compare-popup table tr.row_price td,
      .locks-compare-popup table tr.row_cta td,
      .locks-compare-popup table tr.row_cutoff td {
        padding-block: 0.5rem;
      }
      .locks-compare-popup table tr.row_info td {
        vertical-align: top;
      }
      .locks-compare-popup table tr > td:nth-child(3) {
        display: none;
      }
      .locks-compare-popup table .select {
        position: relative;
        width: 100%;
      }
      .locks-compare-popup table .select .trigger {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        background-color: #fff;
        border: 1.5px solid #e8e9eb;
        border-radius: 2px;
        padding: 1rem 2rem 1rem 1rem;
        height: 70px;
        font-weight: 600;
      }
      .locks-compare-popup table .select .trigger:after {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/c436165bf05bba37de8351ac6640ef40.svg) no-repeat center;
        background-size: cover;
        width: 14px;
        height: 7px;
        content: "";
      }
      .locks-compare-popup table .select .trigger span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .locks-compare-popup table .select .options {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        max-height: 320px;
        border-radius: 4px;
        background: #676669;
        padding: 10px 0;
        overflow-y: auto;
        z-index: 1;
      }
      .locks-compare-popup table .select.open .options {
        display: block;
      }
      .locks-compare-popup table .select .options .option {
        position: relative;
        cursor: pointer;
        padding: 3px 42px;
        color: #fff;
        line-height: 1.7;
      }
      .locks-compare-popup table .select .options .option.selected:before {
        display: block;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/85a786792f447dd5bad3b7b35c183ac9.svg) no-repeat center;
        background-size: cover;
        width: 18px;
        height: 17px;
        content: "";
      }
      .locks-compare-popup table .select .options .option:hover {
        background: #4687e9;
      }
      .locks-compare-popup table .row_image img {
        max-height: 250px;
        width: auto;
        display: block;
        margin: 0 auto;
      }
      .locks-compare-popup table .info_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
      .locks-compare-popup table .info_wrapper p:first-child {
        font-size: 14px;
      }
      .locks-compare-popup table .info_wrapper p:nth-child(n+2) {
        font-size: 12px;
      }
      .locks-compare-popup table .variant_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
      }
      .locks-compare-popup table .variant_wrapper .variant_model,
      .locks-compare-popup table .variant_wrapper .variant_color {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }
      .locks-compare-popup table .variant_wrapper .variant_model .item {
        display: block;
        padding: 6px 10px;
        background: #fff;
        color: #000;
        border: 1px solid black;
        cursor: pointer;
        font-size: 11px;
        text-align: center;
      }
      .locks-compare-popup table .variant_wrapper .variant_model .item.active {
        background: #000;
        color: #fff;
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item {
        position: relative;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 100%;
        cursor: pointer;
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item.active:after {
        position: absolute;
        top: -4px;
        left: -4px;
        content: "";
        width: 26px;
        height: 26px;
        border-radius: 100%;
        border: 1px solid #000;
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item[data-color="Onyx Black"] {
        background: url(//prismplus.sg/cdn/shop/files/OnyxBlack_941bea1c-f442-430f-b427-8c0430483298.svg?v=1762919909&width=50);
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item[data-color="Copper Rose"] {
        background: url(//prismplus.sg/cdn/shop/files/3-CopperRose.svg?v=1726733940&width=50);
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item[data-color="Space Grey"] {
        background: url(https://cdn.shopify.com/s/files/1/1595/6213/files/1-SpaceGray.svg?v=1723997765&width=50);
      }
      .locks-compare-popup table .variant_wrapper .variant_color .item[data-color="Nickel Silver"] {
        background: url(https://cdn.shopify.com/s/files/1/1595/6213/files/2-NickelSilver.svg?v=1723997765&width=50);
      }
      .locks-compare-popup table .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .locks-compare-popup table .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }
      .locks-compare-popup table .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }
      .locks-compare-popup table .cta_wrapper a {
        width: 100%;
        padding: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }
      .locks-compare-popup table .data_wrapper {
        padding-block: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
      .locks-compare-popup table .data_wrapper img {
        max-height: 150px;
      }
      .locks-compare-popup table .data_wrapper:empty {
        display: none;
      }
      .locks-compare-popup table .data_wrapper p {
        font-size: 12px;
      }
      @media (min-width: 1024px) {
        .locks-compare-btn {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }
        .locks-compare-popup p.title {
          font-size: 32px;
        }
        .locks-compare-popup p.subtitle {
          font-size: 16px;
        }
        .locks-compare-popup table td {
          padding-inline: 8px;
        }
        .locks-compare-popup table tr > td:nth-child(3) {
          display: table-cell;
        }
        .locks-compare-popup table .select .trigger {
          padding: 1rem 3rem 1rem 1rem;
        }
        .locks-compare-popup table .info_wrapper p:first-child {
          font-size: 20px;
        }
        .locks-compare-popup table .info_wrapper p:nth-child(n+2) {
          font-size: 14px;
        }
        .locks-compare-popup table .variant_wrapper .variant_model .item {
          padding: 8px 12px;
          font-size: 14px;
        }
        .locks-compare-popup table .price_wrapper .price {
          font-size: 22px;
        }
        .locks-compare-popup table .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }
      }
    `;
    document.head.append(style);
  }

  function mainFunc() {
    if (location.pathname.includes("/products/")) {
      addCompareBtnPDP();
    } else if (location.pathname.includes("/collections/")) {
      addCompareBtn();
    }
    addComparePopup();
    handleEvents();
    assignCssVariables();
  }

  function addCompareBtn() {
    const compareBtn = document.createElement("button");
    compareBtn.innerText = "Compare Locks";
    compareBtn.classList.add("locks-compare-btn");
    $("#ultimate-home-bundles").after(compareBtn);

    return compareBtn;
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button");
    button.textContent = "Compare";
    button.addEventListener("click", function () {
      $(".locks-compare-popup").toggleClass("show");
    });
    $(".nav2-content .spacer").after(button);
  }

  function addComparePopup() {
    const comparePopup = document.createElement("div");
    comparePopup.classList.add("locks-compare-popup");
    comparePopup.innerHTML = `
      <div class="locks-compare-popup-close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/></svg>
      </div>
      <div class="page-width">
        <p class="title">Compare Locks</p>
        <p class="subtitle">Discover your perfect home security companion choose the right lock for smarter, safer living.</p>
        <table class="locks-compare-table">
          <tbody></tbody>
        </table>
      </div>
    `;
    document.body.append(comparePopup);

    fillComparePopup(comparePopup);

    return comparePopup;
  }

  function fillComparePopup(comparePopup) {
    const tbody = $(comparePopup).find("table tbody");

    for (const x in [...Array(15).keys()]) {
      const rowIndex = Number(x);
      const row = document.createElement("tr");
      tbody.append(row);

      switch (rowIndex) {
        case 0:
          $(row).addClass("row_select");
          break;
        case 1:
          $(row).addClass("row_image");
          break;
        case 2:
          $(row).addClass("row_info");
          break;
        case 3:
          $(row).addClass("row_variant");
          break;
        case 4:
          $(row).addClass("row_price");
          break;
        case 5:
          $(row).addClass("row_cta");
          break;
        case 6:
          $(row).addClass("row_cutoff");
          break;
        default:
          $(row).addClass("row_data");
          break;
      }

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell = document.createElement("td");
        row.append(cell);

        const colData = Object.entries(data)[colIndex];
        const groupNames = Object.keys(data);
        const groupName = colData[0];
        const groupData = colData[1];

        const modelNames = Object.keys(groupData.models);
        const models = Object.entries(groupData.models);
        const defaultModelData = models[0][1];
        const colorNames = Object.keys(defaultModelData.colors);
        const colors = Object.entries(defaultModelData.colors);
        const defaultColorData = colors[0][1];

        if (rowIndex == 0) {
          cell.innerHTML = `
            <div class="select">
              <div class="trigger">
                <span>${groupName}</span>
              </div>
              <div class="options">
                ${groupNames.map((n, i) => `<div class="option ${colIndex == i ? "selected" : ""}">${n}</div>`).join("")}
              </div>
            </div>
          `;
        } else if (rowIndex == 1) {
          cell.innerHTML = `
            <div class="image_wrapper">
              <img src="${defaultColorData.image_url}" alt="" width="" height="" />
            </div>
          `;
        } else if (rowIndex == 2) {
          cell.innerHTML = `
            <div class="info_wrapper">
              <p>${groupName}</p>
              <p>${groupData.type}</p>
              ${groupName.includes("2026") ? "<p>2026 Model</p>" : ""}
            </div>
          `;
        } else if (rowIndex == 3) {
          cell.innerHTML = `
            <div class="variant_wrapper">
              <ul class="variant_model">
                ${modelNames.map((n, i) => `<li class="item ${i == 0 ? "active" : ""}">${n}</li>`).join("")}
              </ul>
              <ul class="variant_color">
                ${colorNames.map((n, i) => `<li class="item ${i == 0 ? "active" : ""}" data-color="${n}"></li>`).join("")}
              </ul>
            </div>
          `;
        } else if (rowIndex == 4) {
          cell.innerHTML = `
            <div class="price_wrapper">
              <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161" />
              <span class="price">${theme.Currency.formatMoney(defaultColorData.price)}</span>
              <s class="compare_at_price">${theme.Currency.formatMoney(defaultColorData.compare_at_price)}</s>
            </div>
          `;
        } else if (rowIndex == 5) {
          cell.innerHTML = `
            <div class="cta_wrapper">
              <a href="${groupData.url}">Shop Now</a>
            </div>
          `;
        } else if (rowIndex == 6) {
          cell.innerHTML = ``;
        } else {
          let dataRowCount = rowIndex - 7;
          const filteredDetails = Object.fromEntries(
            Object.entries(defaultModelData.details).filter(
              ([key, value]) => value !== null,
            ),
          );
          const curRow = Object.entries(filteredDetails)[dataRowCount];
          const dKey = curRow[0];
          const dVal = curRow[1];

          const dataWrapper = document.createElement("div");
          dataWrapper.classList.add("data_wrapper", `data-${dKey}`);
          cell.append(dataWrapper);
          dataWrapper.innerHTML = getDetailsHtml(dKey, dVal);
        }
      }
    }
  }

  function handleEvents() {
    const compareBtn = $(".locks-compare-btn");
    const comparePopup = $(".locks-compare-popup");
    const closeBtn = comparePopup.find(".locks-compare-popup-close-btn");
    const select = comparePopup.find(".select .trigger");
    const option = comparePopup.find(".select .option");
    const variantModel = comparePopup.find(".variant_model");
    const variantColor = comparePopup.find(".variant_color");

    compareBtn.on("click", function () {
      comparePopup.addClass("show");
    });
    closeBtn.on("click", function () {
      comparePopup.removeClass("show");
    });
    select.on("click", function () {
      $(this).closest(".select").toggleClass("open");
    });
    variantColor.on("click", ".item", function () {
      $(this).siblings(".item.active").removeClass("active");
      $(this).addClass("active");

      const curIndex = $(this).closest("td").index();
      const curGroup = $(
        `.locks-compare-table .row_select td:nth-child(${curIndex + 1}) .option.selected`,
      ).text();
      const curModel = $(this)
        .closest(".variant_wrapper")
        .find(".variant_model .item.active")
        .text();
      const curColor = $(this).attr("data-color");

      const { image_url, price, compare_at_price } =
        data[curGroup].models[curModel].colors[curColor];

      $(
        `.locks-compare-table .row_image td:nth-child(${curIndex + 1}) img`,
      ).attr("src", image_url);
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .price`,
      ).text(theme.Currency.formatMoney(price));
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .compare_at_price`,
      ).text(theme.Currency.formatMoney(compare_at_price));
    });
    variantModel.on("click", ".item", function () {
      $(this).siblings(".item.active").removeClass("active");
      $(this).addClass("active");

      const curIndex = $(this).closest("td").index();
      const curGroup = $(
        `.locks-compare-table .row_select td:nth-child(${curIndex + 1}) .option.selected`,
      ).text();
      const curModel = $(this).text();
      const curColor = $(this)
        .closest(".variant_wrapper")
        .find(".variant_color .item.active")
        .attr("data-color");

      const modelData = data[curGroup].models[curModel];
      const colors = Object.entries(modelData.colors);
      const details = modelData.details;

      // update variant_color
      const curVariantColor = $(this)
        .closest(".variant_wrapper")
        .find(".variant_color");
      curVariantColor.empty();
      curVariantColor.html(
        colors
          .map(
            (c, i) =>
              `<li class="item ${i == 0 ? "active" : ""}" data-color="${c[0]}"></li>`,
          )
          .join(""),
      );

      // update price and image
      const { image_url, price, compare_at_price } = colors[0][1];
      $(
        `.locks-compare-table .row_image td:nth-child(${curIndex + 1}) img`,
      ).attr("src", image_url);
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .price`,
      ).text(theme.Currency.formatMoney(price));
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .compare_at_price`,
      ).text(theme.Currency.formatMoney(compare_at_price));

      // update details
      const curColRowData = $(
        `.locks-compare-table .row_data td:nth-child(${curIndex + 1})`,
      );
      curColRowData.empty();
      const filteredDetails = Object.fromEntries(
        Object.entries(details).filter(([key, value]) => value !== null),
      );

      curColRowData.each(function (i, cell) {
        const curRowDetails = Object.entries(filteredDetails)[i];
        const dataWrapper = document.createElement("div");
        dataWrapper.classList.add("data_wrapper", `data-${curRowDetails[0]}`);
        dataWrapper.innerHTML = getDetailsHtml(
          curRowDetails[0],
          curRowDetails[1],
        );
        cell.append(dataWrapper);
      });
    });
    option.on("click", function () {
      $(this).siblings(".option.selected").removeClass("selected");
      $(this).addClass("selected");
      $(this).closest(".select").removeClass("open");

      const groupName = $(this).text();
      $(this).closest(".select").find(".trigger span").text(groupName);

      const groupData = data[groupName];
      const curIndex = $(this).closest("td").index();

      // update info
      $(
        `.locks-compare-table .row_info td:nth-child(${curIndex + 1}) .info_wrapper`,
      ).html(`
        <p>${groupName}</p>
        <p>${groupData.type}</p>
        ${groupName.includes("2026") ? "<p>2026 Model</p>" : ""}
      `);

      // update variant_wrapper
      const models = Object.entries(groupData.models);
      const modelNames = models.map((m) => m[0]);
      const defaultModelColors = Object.entries(models[0][1].colors);
      const colorNames = defaultModelColors.map((c) => c[0]);

      const variantModel = $(
        `.locks-compare-table .row_variant td:nth-child(${curIndex + 1}) .variant_model`,
      );
      const variantColor = $(
        `.locks-compare-table .row_variant td:nth-child(${curIndex + 1}) .variant_color`,
      );
      variantModel.empty();
      variantColor.empty();

      variantModel.html(
        modelNames.map(
          (n, i) => `<li class="item ${i == 0 ? "active" : ""}">${n}</li>`,
        ),
      );

      variantColor.html(
        colorNames.map(
          (n, i) =>
            `<li class="item ${i == 0 ? "active" : ""}" data-color="${n}"></li>`,
        ),
      );

      // update image
      $(
        `.locks-compare-table .row_image td:nth-child(${curIndex + 1}) img`,
      ).attr("src", defaultModelColors[0][1].image_url);

      // upadte price
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .price`,
      ).html(theme.Currency.formatMoney(defaultModelColors[0][1].price));
      $(
        `.locks-compare-table .row_price td:nth-child(${curIndex + 1}) .compare_at_price`,
      ).html(
        theme.Currency.formatMoney(defaultModelColors[0][1].compare_at_price),
      );

      // update cta
      $(`.locks-compare-table .row_cta td:nth-child(${curIndex + 1}) a`).attr(
        "href",
        groupData.url,
      );

      // update details

      const defaultModelDetails = models[0][1].details;
      const filteredDetails = Object.entries(defaultModelDetails).filter(
        ([key, value]) => value !== null,
      );
      const rowDataCells = $(
        `.locks-compare-table .row_data td:nth-child(${curIndex + 1})`,
      );
      rowDataCells.empty();
      rowDataCells.each(function (i, cell) {
        const dKey = filteredDetails[i][0];
        const dVal = filteredDetails[i][1];

        const dataWrapper = document.createElement("div");
        dataWrapper.classList.add("data_wrapper", `data-${dKey}`);
        dataWrapper.innerHTML = getDetailsHtml(dKey, dVal);
        cell.append(dataWrapper);
      });
    });
  }

  function assignCssVariables() {
    const comparePopup = $(".locks-compare-popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--select-height",
        `${$(".locks-compare-table .row_select").height()}px`,
      );
      comparePopup.style.setProperty(
        "--variant-height",
        `${$(".locks-compare-table .row_variant").height()}px`,
      );
      comparePopup.style.setProperty(
        "--price-height",
        `${$(".locks-compare-table .row_price").height()}px`,
      );
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }

  function getDetailsHtml(dKey, dVal) {
    let html = ``;

    switch (dKey) {
      case "forType":
        switch (dVal) {
          case "door":
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/L01_3x7_door.jpg?v=1747987920" alt="" width="" height="" /><p><b>For Doors</b></p>`;
            break;
          case "gate":
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EA01ABL.jpg?v=1750671259" alt="" width="" height="" /><p><b>For Regular Gates</b></p>`;
            break;
          case "both":
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/for_door_gate.png?v=1772522280" alt="" width="" height="" /><p><b>For Doors & Glass,Privacy & Regular Gates</b></p>`;
            break;
          case "gate-all":
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Glass_Regular_Privacy.png?v=1773980530" alt="" width="" height="" /><p><b>For Regular, Glass, Privacy Gates</b></p>`;
            break;
        }
        break;
      case "clearance":
        switch (dVal) {
          case 30:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/clearance_30mm.png?v=1772528410" alt="" width="" height="" /><p><b>At least 30mm Clearance Needed Only</b><br/>Fits with a lot more HDB door & gate</p>`;
            break;
          case 45:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/clearance_45mm.png?v=1772528410" alt="" width="" height="" /><p><b>At least 45mm Clearance Needed Only</b><br/>Fits with a lot more HDB door & gate</p>`;
            break;
          case 75:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/clearance_75mm.png?v=1772528410" alt="" width="" height="" /><p><b>At least 75mm Clearance Needed Only</b><br/>Fits with a lot more HDB door & gate</p>`;
            break;
        }
        break;
      case "twoWayVideo":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/video_call_2_way_door.png?v=1772528799" alt="" width="" height="" /><p><b>2-Way Video Calling</b><br/>Inbuilt Cat Eye Doorbell & Wi-Fi</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/video_call_2_way_gate.png?v=1772528798" alt="" width="" height="" /><p><b>2-Way Video Calling</b><br/>Inbuilt Cat Eye Doorbell & Wi-Fi</p>`;
            break;
        }
        break;
      case "thickness":
        if (dVal) {
          html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/UltraSlim.svg?v=1772779319" alt="" width="" height="" /><p><b>Ultra Slim Thickness</b><br/>${dVal}mm Thickness</p>`;
        }
        break;
      case "unlockMode":
        if (dVal) {
          html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ModeUnlock.svg?v=1772779319" alt="" width="" height="" /><p><b>Modes of Unlock</b><br/>${dVal}</p>`;
        }
        break;
      case "duoSync":
        if (dVal) {
          html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/DuoSync.svg?v=1772779319" alt="" width="" height="" /><p><b>DuoSync (Door & Gate)</b><br/>Yes (2 way)</p>`;
        }
        break;
      case "battery":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Battery.svg?v=1772779319" alt="" width="" height="" /><p><b>Battery & Battery Life</b><br/>5000 mAh Li-Ion (rechargeable & replaceable), 2500 unlocks OR up to 6 months standby</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Battery.svg?v=1772779319" alt="" width="" height="" /><p><b>Battery & Battery Life</b><br/>5000 mAh Li-Ion (rechargeable & replaceable), 2500 unlocks OR up to 4 months standby</p>`;
            break;
        }
        break;
      case "durability":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Durability.svg?v=1772779320" alt="" width="" height="" /><p><b>Durability</b><br/>Military Grade Durability</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Durability.svg?v=1772779320" alt="" width="" height="" /><p><b>Durability</b><br/>Military Grade Durability & SCDF Fire Safety Standards</p>`;
            break;
        }
        break;
      case "wifi":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Wi-Fi.svg?v=1772779319" alt="" width="" height="" /><p><b>Wi-Fi</b><br/>Inbuilt Wi-Fi 2.4G</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Wi-Fi.svg?v=1772779319" alt="" width="" height="" /><p><b>Wi-Fi</b><br/>Via Wi-Fi 2.4G Gateway</p>`;
            break;
        }
        break;
        break;
    }

    return html;
  }

  // Hard code everything for now since some of the locks have different backend setup
  function getData() {
    const data = {
      "Sentinel 2026": {
        type: "Door Lock",
        url: "/products/prism-sentinel-series-2026",
        models: {
          Sentinel: {
            colors: {
              "Onyx Black": {
                price: 79900,
                compare_at_price: 99900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentinel-OnyxBlack-Thumb1_e2d3582c-b36c-4e54-b956-565c6856ad83.jpg?v=1772780527",
              },
              "Copper Rose": {
                price: 79900,
                compare_at_price: 99900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentinel-CopperRose-Thumb1_814ee6e0-be61-40dc-891b-a3df62d82353.jpg?v=1772780527",
              },
            },
            details: {
              forType: "door",
              clearance: 75,
              twoWayVideo: null,
              thickness: 11.5,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key",
              duoSync: true,
              battery: 2,
              durability: 2,
              wifi: 1,
            },
          },
          "Sentinel Ultra": {
            colors: {
              "Onyx Black": {
                price: 94900,
                compare_at_price: 118600,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentinelUltra-OnyxBlack-Thumb1_6e425983-6eb6-427b-8c25-7d51219293b9.jpg?v=1772780527",
              },
              "Copper Rose": {
                price: 94900,
                compare_at_price: 118600,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentinelUltra-CopperRose-Thumb1_210b6b8f-f126-46a3-96fa-d03ba48f688e.jpg?v=1772780528",
              },
            },
            details: {
              forType: "door",
              clearance: 75,
              twoWayVideo: 1,
              thickness: 11.5,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, 3D Facial Recognition, Palm Vein",
              duoSync: true,
              battery: 2,
              durability: 2,
              wifi: null,
            },
          },
        },
      },
      "Spectre 2026": {
        type: "Door Lock",
        url: "/products/prism-spectre-series-2026",
        models: {
          Spectre: {
            colors: {
              "Onyx Black": {
                price: 89900,
                compare_at_price: 112400,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Spectre-OnyxBlack-Thumb1_9589c25b-4d02-4a9c-8b70-7139ab3d66a1.jpg?v=1772780279",
              },
              "Copper Rose": {
                price: 89900,
                compare_at_price: 112400,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Spectre-CopperRose-Thumb1_fd07f92f-49da-4672-a81a-814949e7cb67.jpg?v=1772780280",
              },
            },
            details: {
              forType: "door",
              clearance: 30,
              twoWayVideo: null,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key",
              duoSync: true,
              battery: 2,
              durability: 2,
              wifi: 1,
            },
          },
          "Spectre Ultra": {
            colors: {
              "Onyx Black": {
                price: 104900,
                compare_at_price: 131100,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SpectreUltra-OnyxBlack-Thumb1_10bdbc39-7459-43f6-be0c-9230f3a6832c.jpg?v=1772780279",
              },
              "Copper Rose": {
                price: 104900,
                compare_at_price: 131100,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SpectreUltra-CopperRose-Thumb1_38c33a48-50a2-4701-8ec1-49c4b0c9d685.jpg?v=1772780280",
              },
            },
            details: {
              forType: "door",
              clearance: 30,
              twoWayVideo: 1,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, 3D Facial Recognition, Palm Vein",
              duoSync: true,
              battery: 2,
              durability: 2,
              wifi: null,
            },
          },
        },
      },
      "Sentry 2026": {
        type: "Gate Lock",
        url: "/products/prism-sentry-series-2026",
        models: {
          Sentry: {
            colors: {
              "Onyx Black": {
                price: 59900,
                compare_at_price: 74900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry-OnyxBlack-Thumb1_1ddb65e0-e3fc-4692-aed2-da78a1c2e264.jpg?v=1772780467",
              },
              "Copper Rose": {
                price: 59900,
                compare_at_price: 74900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry-CopperRose-Thumb1_71b7ed9b-661e-4af9-b53d-6a71697cf0d8.jpg?v=1772780467",
              },
            },
            details: {
              forType: "gate-all",
              clearance: 45,
              twoWayVideo: null,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, Remote",
              duoSync: true,
              battery: 2,
              durability: 1,
              wifi: 1,
            },
          },
          "Sentry Ultra": {
            colors: {
              "Onyx Black": {
                price: 74900,
                compare_at_price: 93600,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentryUltra-OnyxBlack-Thumb1_f4ec1801-b487-456d-8250-08f3ff0fed77.jpg?v=1772780467",
              },
              "Copper Rose": {
                price: 74900,
                compare_at_price: 93600,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentryUltra-CopperRose-Thumb1_77964e08-c3a9-4072-9c86-be2a653585a4.jpg?v=1772780468",
              },
            },
            details: {
              forType: "gate-all",
              clearance: 45,
              twoWayVideo: 2,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, Remote, 3D Facial Recognition, Palm Vein",
              duoSync: true,
              battery: 2,
              durability: 1,
              wifi: null,
            },
          },
        },
      },
      /*
      Sentinel: {
        type: "Door Lock",
        url: "/products/prism-sentinel-series",
        models: {
          Sentinel: {
            colors: {
              "Space Grey": {
                price: 79900,
                compare_at_price: 123900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentinel-SpaceGray-1.jpg?v=1772785675",
              },
              "Copper Rose": {
                price: 77900,
                compare_at_price: 123900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentinel-CopperRose-1.jpg?v=1772785675",
              },
            },
            details: {
              forType: "door",
              clearance: 75,
              twoWayVideo: null,
              thickness: 11.5,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key",
              duoSync: true,
              battery: 1,
              durability: 2,
              wifi: 2,
            },
          },
          "Sentinel Pro": {
            colors: {
              "Space Grey": {
                price: 89900,
                compare_at_price: 137900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentinelPro-SpaceGray-1.jpg?v=1772785676",
              },
              "Copper Rose": {
                price: 87900,
                compare_at_price: 137900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentinelPro-CopperRose-1.jpg?v=1772785675",
              },
              "Nickel Silver": {
                price: 84900,
                compare_at_price: 137900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SentinelPro-NickelSilver-1.jpg?v=1772785675",
              },
            },
            details: {
              forType: "door",
              clearance: 75,
              twoWayVideo: null,
              thickness: 11.5,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, 3D Facial Recognition",
              duoSync: true,
              battery: 1,
              durability: 2,
              wifi: 2,
            },
          },
        },
      },
      */
      Sentry: {
        type: "Gate Lock",
        url: "/products/prism-sentry-series",
        models: {
          Sentry: {
            colors: {
              /*
              "Space Grey": {
                price: 57900,
                compare_at_price: 79900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry_Space-Gray_1_Laz.jpg?v=1772785675",
              },
              "Copper Rose": {
                price: 55900,
                compare_at_price: 79900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry_Copper-Rose_1_Laz.jpg?v=1772785676",
              },
              */
              "Nickel Silver": {
                price: 57900,
                compare_at_price: 79900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry_Nickel-Silver_1_Laz.jpg?v=1772785676",
              },
            },
            details: {
              forType: "gate",
              clearance: 45,
              twoWayVideo: null,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, Remote",
              duoSync: true,
              battery: 1,
              durability: 1,
              wifi: 2,
            },
          },
          "Sentry Pro": {
            colors: {
              /*
              "Space Grey": {
                price: 64900,
                compare_at_price: 89900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry-Pro_Space-Gray_1_Laz.jpg?v=1772785677",
              },
              */
              "Copper Rose": {
                price: 62900,
                compare_at_price: 89900,
                image_url:
                  "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Sentry-Pro_Copper-Rose_1_Laz.jpg?v=1772785676",
              },
            },
            details: {
              forType: "gate",
              clearance: 45,
              twoWayVideo: null,
              thickness: 20,
              unlockMode:
                "Keypad, Fingerprint, Card & Sticker, Physical Key, Remote, 3D Facial Recognition",
              duoSync: true,
              battery: 1,
              durability: 1,
              wifi: 2,
            },
          },
        },
      },
    };

    return data;
  }

  async function getProductData(handle) {
    return await (await fetch(`/products/${handle}.js`)).json();
  }
})();
